import React, { Component } from "react";
import {goodCompany} from './goodCompanyImages';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

var settings = {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed:1200,
            responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 380,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        }
      ]
};
class MobileSlider extends Component{

	constructor(props){
		super(props);
		this.state={


		}
	}

	render(){
		return(
			<>
				<Slider {...settings} className="mobile-scroll">
						
						  <li>
						    <div className="icon-img">
						      <img src={goodCompany.social_networkers.url} alt={"Social Networkers"}/>
						    </div>
						    <p>Social Networkers</p>
						  </li>
						  <li>
						    <div className="icon-img">
						      <img src={goodCompany.bloggers_vloggers.url} alt={"Bloggers & Vloggers"}/>
						    </div>
						    <p>Bloggers <br/> & Vloggers</p>
						  </li>
						  <li> <div className="icon-img">
						    <img src={goodCompany.journalist_authors.url} alt={"Journalist & Authors"}/>
						  </div>
						  <p>Journalist
						  & Authors</p></li>
						  <li> <div className="icon-img">
						    <img src={goodCompany.photographers_videographers.url} alt={""}/>
						  </div>
						  <p>Photographers <br/>
						  & Videographers</p></li>
						  <li> <div className="icon-img">
						    <img src={goodCompany.models_artists.url} alt={"Models & Artists"}/>
						  </div>
						  <p>Models <br/>
						  & Artists</p></li>
						  <li> <div className="icon-img">
						    <img src={goodCompany.businesses_brands.url} alt={"Businesses & Brands"}/>
						  </div>
						  <p>Businesses <br/>
						  & Brands</p></li>
						  <li> <div className="icon-img">
						    <img src={goodCompany.influencers_entertainers.url} alt={"Influencers & Entertainers"}/>
						  </div>
						  <p>Influencers <br/>
						  & Entertainers</p></li>
			  	</Slider>
			  </>
			)
	}
}

export default MobileSlider;